import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

export const Footer = () => (
  <footer className="border-t border-[#E5E2DC] bg-[#FDFCFB]" data-testid="site-footer">
    <div className="container-pad mx-auto max-w-[1400px] py-16 grid md:grid-cols-4 gap-10">
      <div className="md:col-span-1">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-9 h-9 rounded-xl bg-[#1E4D3B] grid place-items-center text-[#FDFCFB] font-display font-semibold">F</div>
          <span className="font-display text-xl font-semibold text-[#121C17]">FinSahayak</span>
        </div>
        <p className="text-sm text-[#5C6661] leading-relaxed max-w-xs">
          India's friendliest digital compliance partner for MSMEs, freelancers and growing businesses.
        </p>
      </div>

      <div>
        <h4 className="label-eyebrow mb-4">Services</h4>
        <ul className="space-y-2 text-sm">
          <li><Link to="/services" className="text-[#5C6661] hover:text-[#121C17]">GST Registration</Link></li>
          <li><Link to="/services" className="text-[#5C6661] hover:text-[#121C17]">ITR Filing</Link></li>
          <li><Link to="/services" className="text-[#5C6661] hover:text-[#121C17]">Company Registration</Link></li>
          <li><Link to="/services" className="text-[#5C6661] hover:text-[#121C17]">Accounting</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="label-eyebrow mb-4">Company</h4>
        <ul className="space-y-2 text-sm">
          <li><Link to="/about" className="text-[#5C6661] hover:text-[#121C17]">About</Link></li>
          <li><Link to="/pricing" className="text-[#5C6661] hover:text-[#121C17]">Pricing</Link></li>
          <li><Link to="/contact" className="text-[#5C6661] hover:text-[#121C17]">Contact</Link></li>
          <li><Link to="/privacy" className="text-[#5C6661] hover:text-[#121C17]">Privacy Policy</Link></li>
          <li><Link to="/terms" className="text-[#5C6661] hover:text-[#121C17]">Terms</Link></li>
          <li><Link to="/refund" className="text-[#5C6661] hover:text-[#121C17]">Refund Policy</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="label-eyebrow mb-4">Reach us</h4>
        <ul className="space-y-3 text-sm text-[#5C6661]">
          <li className="flex items-center gap-2"><Phone size={14} /> +91 99999 99999</li>
          <li className="flex items-center gap-2"><Mail size={14} /> hello@finsahayak.com</li>
          <li className="flex items-start gap-2"><MapPin size={14} className="mt-0.5" /> Bengaluru, Karnataka, India</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-[#E5E2DC] py-6 container-pad mx-auto max-w-[1400px] text-xs text-[#5C6661] flex flex-col md:flex-row justify-between gap-3">
      <span>© {new Date().getFullYear()} FinSahayak Technologies Pvt. Ltd. All rights reserved.</span>
      <span>Made with care in India 🇮🇳</span>
    </div>
  </footer>
);
